import { createElement, Fragment } from 'react';
import cn from 'classnames';
import { Button } from '../Button/index.js';
import styles from 'ui-components/Pagination.scss';

var range = function range(start, end) {
  var length = end + 1 - start;
  return Array.from({
    length: length
  }, function (_, i) {
    return start + i;
  });
};
var DefaultButtonComponent = function DefaultButtonComponent(_ref) {
  var _cn;
  var page = _ref.page,
    active = _ref.active,
    disabled = _ref.disabled,
    className = _ref.className,
    onChange = _ref.onChange,
    children = _ref.children,
    size = _ref.size,
    id = _ref.id;
  return /*#__PURE__*/createElement(Button, {
    key: id,
    size: size,
    variant: active ? "primary" : "ghost",
    className: cn(styles.button, className, (_cn = {}, _cn[styles.buttonActive] = active, _cn)),
    disabled: disabled,
    onClick: function onClick() {
      return onChange && onChange(page);
    }
  }, children);
};
var DefaultPrevComponent = function DefaultPrevComponent() {
  return /*#__PURE__*/createElement("span", null, "\xAB");
};
var DefaultNextComponent = function DefaultNextComponent() {
  return /*#__PURE__*/createElement("span", null, "\xBB");
};
var Pagination = function Pagination(_ref2) {
  var _ref2$size = _ref2.size,
    size = _ref2$size === void 0 ? "medium" : _ref2$size,
    className = _ref2.className,
    currentPage = _ref2.currentPage,
    pageCount = _ref2.pageCount,
    onChange = _ref2.onChange,
    _ref2$maxButtonCount = _ref2.maxButtonCount,
    maxButtonCount = _ref2$maxButtonCount === void 0 ? 10 : _ref2$maxButtonCount,
    _ref2$ButtonComponent = _ref2.ButtonComponent,
    ButtonComponent = _ref2$ButtonComponent === void 0 ? DefaultButtonComponent : _ref2$ButtonComponent,
    _ref2$PrevComponent = _ref2.PrevComponent,
    PrevComponent = _ref2$PrevComponent === void 0 ? DefaultPrevComponent : _ref2$PrevComponent,
    _ref2$NextComponent = _ref2.NextComponent,
    NextComponent = _ref2$NextComponent === void 0 ? DefaultNextComponent : _ref2$NextComponent;
  var _maxButtonCount = Math.min(Math.max(maxButtonCount, 5), pageCount);
  var halfMaxButtonCount = Math.floor(_maxButtonCount / 2);
  var leftFromStart = Math.max(halfMaxButtonCount - (currentPage - 1), 0);
  var leftFromEnd = Math.max(halfMaxButtonCount - (pageCount - currentPage), 0);
  var from = Math.max(1, currentPage - halfMaxButtonCount - leftFromEnd);
  var to = Math.min(pageCount, currentPage + halfMaxButtonCount + leftFromStart);
  var buttons = range(from, to);
  var showFirstPageButton = typeof buttons.find(function (page) {
    return page === 1;
  }) === "undefined";
  var showLastPageButton = typeof buttons.find(function (page) {
    return page === pageCount;
  }) === "undefined";
  if (showFirstPageButton) {
    buttons = buttons.slice(1);
  }
  if (showLastPageButton) {
    buttons = buttons.slice(0, buttons.length - 1);
  }
  return /*#__PURE__*/createElement("div", {
    className: cn(styles.block, className)
  }, /*#__PURE__*/createElement(ButtonComponent, {
    id: "button_prev",
    styles: styles,
    active: false,
    size: size,
    page: Math.max(1, currentPage - 1),
    className: styles.previous,
    disabled: currentPage === 1,
    onChange: onChange
  }, /*#__PURE__*/createElement(PrevComponent, null)), showFirstPageButton && /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement(ButtonComponent, {
    id: "button_1",
    styles: styles,
    active: currentPage === 1,
    page: 1,
    size: size,
    onChange: onChange
  }, "1"), /*#__PURE__*/createElement("span", null, "\u22EF")), buttons.map(function (x) {
    return /*#__PURE__*/createElement(ButtonComponent, {
      key: x,
      id: "button_" + x,
      styles: styles,
      active: currentPage === x,
      page: x,
      size: size,
      onChange: onChange
    }, x);
  }), showLastPageButton && /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement("span", null, "\u22EF"), /*#__PURE__*/createElement(ButtonComponent, {
    id: "button_" + pageCount,
    styles: styles,
    active: currentPage === pageCount,
    page: pageCount,
    size: size,
    onChange: onChange
  }, pageCount)), /*#__PURE__*/createElement(ButtonComponent, {
    id: "button_next",
    styles: styles,
    active: false,
    page: Math.min(pageCount, currentPage + 1),
    className: styles.next,
    disabled: currentPage === pageCount,
    size: size,
    onChange: onChange
  }, /*#__PURE__*/createElement(NextComponent, null)));
};

export { Pagination };
//# sourceMappingURL=index.js.map
